export default __webpack_public_path__ + "static/media/paper-parental-engagement.f7dcf2a4.pdf";